"use client";

import { clsx } from "clsx";
import { SwiperSlide } from "swiper/react";
import SwiperCarousel from "@/components/plugins/swiper/SwiperCarousel";
import TextHeader from "@/components/typography/TextHeader";
import TextSubHeader from "@/components/typography/TextSubHeader";
import Button from "@/components/ui/Button";
import { useLeadModal } from "@/contexts/leadModal";

export default function KeyPros() {
  const leadModal = useLeadModal();

  const items = [
    {
      title: "Start budowy",
      content: "Największy wzrost ceny apartamentu w czasie, najniższe ceny",
    },
    {
      title: "100 m",
      subtitle: "od stoku Szczyrk",
      content:
        "Unikalna lokalizacja, 10 min spacerem od centrum kurortu, który tętni życiem przez cały rok",
    },
    {
      title: "5*",
      subtitle: "standard z bogatą infrastrukturą",
      content:
        "Obiekt przyciąga gości bez względu na sezon i pracuje na Twój zysk",
    },
    {
      title: "12,1%",
      subtitle: "nawet",
      subtitleFirst: true,
      content: "Przychód w skali roku, w modelu podziałowym 70/30",
    },
    {
      title: "Tremonti",
      content: "Kolejny obiekt pod cenioną i lubianą marką hotelową",
    },
  ];

  return (
    <div
      className="bg-white pb-16 pt-16 text-[#151922] lg:pb-24 lg:pt-24"
      id={"key-pros"}
    >
      <div className="m-auto mb-10 max-w-screen-sm px-5 lg:mb-14">
        <TextSubHeader>
          <h2>Tremonti Szczyrk</h2>
        </TextSubHeader>
        <TextHeader>Dlaczego warto zainwestować?</TextHeader>
      </div>
      <div className="m-auto max-w-screen-xl px-5"></div>
      <SwiperCarousel
        className="!max-w-screen-xl lg:!pr-0"
        paginationClassName="!bg-[#34EEFF]/30"
        scrollbar={false}
        pagination={{}}
        breakpoints={{
          0: {
            slidesPerView: 1,
            spaceBetween: 20,
            slidesOffsetAfter: -28,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 20,
            slidesOffsetAfter: 0,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 20,
            slidesOffsetAfter: 0,
          },
          1280: {
            slidesPerView: 5,
            spaceBetween: 20,
            slidesOffsetAfter: 0,
          },
        }}
      >
        {items.map((item, index) => (
          <SwiperSlide key={index} className="h-auto">
            <div
              className={clsx(
                "flex h-full flex-col rounded-3xl border-2 p-6 shadow-[0_10px_0_0_rgba(0,0,0,0.05)] lg:p-7 xl:p-6",
                "flex flex-col justify-evenly gap-y-3 border-[#DCDCE8] bg-white text-center",
              )}
            >
              <div className="flex flex-col items-center">
                <div className="break-words text-[24px]/[28px] font-bold">
                  {item.title}
                </div>
                <div
                  className={clsx(
                    item.subtitleFirst ? "order-first" : "",
                    "text-[16px]/[24px] text-[#151922]/60 lg:text-[18px]/[24px]",
                  )}
                >
                  {item.subtitle}
                </div>
              </div>
              <div
                className={clsx(
                  "text-[16px]/[24px] lg:text-[18px]/[24px]",
                  "text-[#151922]/80",
                )}
              >
                {item.content}
              </div>
            </div>
          </SwiperSlide>
        ))}
      </SwiperCarousel>
      <div className="m-auto max-w-screen-xl px-5">
        <div className="mt-6 flex justify-center lg:mt-0">
          <Button onClick={() => leadModal.setFlow({ flow: "default" })}>
            Zapytaj o ofertę
          </Button>
        </div>
      </div>
    </div>
  );
}
